import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30ecda75"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "user-icon" }
const _hoisted_3 = { class: "user-data" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_5 = { class: "list-items" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Información general")
const _hoisted_7 = {
  class: "list-items-child",
  slot: "content"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Usuario (ID)")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Laboratorio")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("División")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Versión app")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Sincronización")
const _hoisted_13 = {
  class: "list-items-child",
  slot: "content"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Tipo de conexión")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Intervalo")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Próxima")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Última")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Sincronizar ahora")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Versiones maestros")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Ajustes")
const _hoisted_21 = {
  key: 1,
  class: "ion-padding close-scanner"
}
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Cerrar scanner")
const _hoisted_23 = { class: "container" }
const _hoisted_24 = {
  key: 0,
  id: "barcodeReader"
}
const _hoisted_25 = {
  key: 1,
  class: "barcode-scanner--area--container"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "square" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "barcode-scanner--area--outer" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "barcode-scanner--area--inner" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "line" }, " ")
    ])
  ])
], -1))
const _hoisted_27 = [
  _hoisted_26
]

import {computed, onMounted, ref, watch} from 'vue'
import {loadingController, useBackButton} from '@ionic/vue'
import {Network} from '@capacitor/network'
import {Device} from '@capacitor/device'
import {
  IonApp,
  IonContent,
  IonItem,
  IonLabel,
  IonList,
  IonMenu,
  IonNote,
  IonAccordionGroup,
  IonButton,
  IonAccordion,
  IonRouterOutlet,
  IonSplitPane,
  modalController
} from '@ionic/vue'
import {caretDownOutline} from 'ionicons/icons'
import {BarcodeScanner} from '@capacitor-community/barcode-scanner'

import {useAuthStore} from '@/store/auth'
import {useControlStore} from '@/store/control'
import {useAppDeviceInfo, useDateTimeWithSecondsFormat} from '@/composables'
import {useSyncStore} from '@/store/sync'
import {SYNC_TIME_PERIOD} from '@/constants'
import {App} from '@capacitor/app'

import ErrorToast from '@/components/Toast/ErrorToast.vue'
import MessageToast from '@/components/Toast/MessageToast.vue'
import IonicIcon from '@/components/IonicIcon.vue'
import SyncData from '@/views/drawer/SyncDataView.vue'
import Settings from '@/views/drawer/SettingsView.vue'
import {syncJob} from "@/lib/cron-jobs";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const authStore = useAuthStore()
const syncStore = useSyncStore()
const controlStore = useControlStore()

const user = computed(() => authStore.user)

const network = ref('')
const appVersion = ref('')
const nextSync = ref('')

const lastSync = computed(() => {
  const date = new Date(syncStore.lastTimeSync).toISOString()
  return useDateTimeWithSecondsFormat(date)
})

const stopScan = () => {
  controlStore.showAppContent()
  if (authStore.version !== 'pwa') {
    BarcodeScanner.showBackground()
    BarcodeScanner.stopScan()
  }
}

const syncMasters = async () => {
  const loading = await loadingController.create({spinner: 'crescent', message: 'Actualizando maestros...'})
  await loading.present()

  try {
    await syncStore.fillVersions()
    await syncStore.fillSyncState()
  } finally {
    await loading.dismiss()
  }
}

const calculateNextSyncValue = () => {
  if (navigator.onLine) {
    const nextSyncDate = new Date(syncStore.nextSyncDate).toISOString()
    nextSync.value = useDateTimeWithSecondsFormat(nextSyncDate)
  } else {
    nextSync.value = ''
  }
}

watch(
  () => syncStore.nextSyncDate,
  () => {
    calculateNextSyncValue()
  }
)

onMounted(async () => {
  let {version} = await useAppDeviceInfo()
  console.log(version)
  const info = await Device.getInfo()

  switch (info.platform) {
    case 'android':
      authStore.setDeviceType('0')
      break

    case 'ios':
      authStore.setDeviceType('1')
      break

    default:
      authStore.setDeviceType('3')
  }

  if (version === 'web') {
    if (window.location.host === 'pwa.qadux360.app') {
      version = 'pwa'
    }
  }

  useBackButton(10, () => {
    // close scanner if open
    if (controlStore.isAppContentHidden) {
      stopScan()
    }
  })

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      syncJob.stop()
    } else {
      syncJob.start()
    }
  });


  App.addListener('appStateChange', ({isActive}) => {
    if (isActive) {
      //  syncJob.start()
      if (authStore.isUserLoggedIn) {
        // syncMasters()
      }
    } else {
      // syncJob.stop()
    }
  })

  Network.addListener('networkStatusChange', async (status) => {
    if (status.connected && syncStore.canSync()) {
      await syncStore.performSync()
    }
  })

  calculateNextSyncValue()

  const toExactMinute = 60000 - (new Date().getTime() % 60000)
  setInterval(() => calculateNextSyncValue(), toExactMinute)

  appVersion.value = version
  authStore.setVersion(version)

  if (navigator && navigator.connection) {
    network.value = navigator.connection.type
  }

  if (authStore.isUserLoggedIn) {
    await syncMasters()
  }
})

const onBackButtonEvent = async (e: any) => {
  if (e.state.current === '/auth/login') {
    await authStore.logout()
    await authStore.localLogout()
  }
}
window.addEventListener('popstate', onBackButtonEvent)

const onPerformSync = async () => {
  if (navigator.onLine) {
    await syncStore.performSync()
    console.log('ENDER')
    await authStore.me()
  } else {
    controlStore.$patch({
      error: 'Para poder realizar una sincronización de datos es necesario tener una conexión a internet activa'
    })
  }
}

const syncData = async () => {
  const modal = await modalController.create({component: SyncData})
  await modal.present()
}

const settings = async () => {
  const modal = await modalController.create({component: Settings})
  await modal.present()
}

const onMenuWillOpen = () => calculateNextSyncValue()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), {
    class: _normalizeClass({ 'transparent-background': _unref(controlStore).isAppContentHidden })
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonSplitPane), {
        "content-id": "main-content",
        disabled: !_unref(authStore).isUserLoggedIn
      }, {
        default: _withCtx(() => [
          (_unref(authStore).isUserLoggedIn && !_unref(controlStore).isAppContentHidden)
            ? (_openBlock(), _createBlock(_unref(IonMenu), {
                key: 0,
                "content-id": "main-content",
                type: "overlay",
                onIonWillOpen: onMenuWillOpen
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonContent), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonList), { id: "list" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, [
                              _createVNode(IonicIcon, { icon: "personCircle" })
                            ]),
                            _createElementVNode("div", _hoisted_3, [
                              _createElementVNode("p", null, _toDisplayString(_unref(user).name), 1),
                              _createElementVNode("p", null, _toDisplayString(_unref(user).email), 1)
                            ])
                          ]),
                          _hoisted_4,
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_unref(IonAccordionGroup), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonAccordion), { "toggle-icon": _unref(caretDownOutline) }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonItem), {
                                      slot: "header",
                                      lines: "none"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(IonicIcon, {
                                          color: "black",
                                          icon: "informationCircleOutline"
                                        }),
                                        _createVNode(_unref(IonLabel), null, {
                                          default: _withCtx(() => [
                                            _hoisted_6
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createElementVNode("div", _hoisted_7, [
                                      _createVNode(_unref(IonList), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(IonItem), { lines: "none" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(IonLabel), null, {
                                                default: _withCtx(() => [
                                                  _hoisted_8
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_unref(IonNote), {
                                                slot: "end",
                                                color: "primary"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_unref(user).id), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_unref(IonItem), { lines: "none" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(IonLabel), null, {
                                                default: _withCtx(() => [
                                                  _hoisted_9
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_unref(IonNote), {
                                                slot: "end",
                                                color: "primary"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_unref(user).laboratory), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_unref(IonItem), { lines: "none" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(IonLabel), null, {
                                                default: _withCtx(() => [
                                                  _hoisted_10
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_unref(IonNote), {
                                                slot: "end",
                                                color: "primary"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_unref(user).division), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_unref(IonItem), { lines: "none" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(IonLabel), null, {
                                                default: _withCtx(() => [
                                                  _hoisted_11
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_unref(IonNote), {
                                                slot: "end",
                                                color: "primary"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(appVersion.value), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["toggle-icon"]),
                                _createVNode(_unref(IonAccordion), { "toggle-icon": _unref(caretDownOutline) }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonItem), { slot: "header" }, {
                                      default: _withCtx(() => [
                                        _createVNode(IonicIcon, {
                                          color: "black",
                                          icon: "syncOutline"
                                        }),
                                        _createVNode(_unref(IonLabel), null, {
                                          default: _withCtx(() => [
                                            _hoisted_12
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createElementVNode("div", _hoisted_13, [
                                      _createVNode(_unref(IonList), null, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(IonItem), { lines: "none" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(IonLabel), null, {
                                                default: _withCtx(() => [
                                                  _hoisted_14
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_unref(IonNote), {
                                                slot: "end",
                                                color: "primary"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(network.value), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_unref(IonItem), { lines: "none" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(IonLabel), null, {
                                                default: _withCtx(() => [
                                                  _hoisted_15
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_unref(IonNote), {
                                                slot: "end",
                                                color: "primary"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_unref(SYNC_TIME_PERIOD)) + " minutos", 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_unref(IonItem), { lines: "none" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(IonLabel), null, {
                                                default: _withCtx(() => [
                                                  _hoisted_16
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_unref(IonNote), {
                                                slot: "end",
                                                color: "primary"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(nextSync.value), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_unref(IonItem), { lines: "none" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(IonLabel), null, {
                                                default: _withCtx(() => [
                                                  _hoisted_17
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_unref(IonNote), {
                                                slot: "end",
                                                color: "primary"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_unref(lastSync)), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_unref(IonButton), {
                                            color: "primary",
                                            expand: "block",
                                            onClick: onPerformSync
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_18
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["toggle-icon"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonItem), {
                              onClick: syncData,
                              slot: "header",
                              lines: "none"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(IonicIcon, {
                                  color: "black",
                                  icon: "ribbonOutline"
                                }),
                                _createVNode(_unref(IonLabel), null, {
                                  default: _withCtx(() => [
                                    _hoisted_19
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonItem), {
                              onClick: settings,
                              slot: "header",
                              lines: "none"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(IonicIcon, {
                                  color: "black",
                                  icon: "settingsOutline"
                                }),
                                _createVNode(_unref(IonLabel), null, {
                                  default: _withCtx(() => [
                                    _hoisted_20
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(ErrorToast),
          _createVNode(MessageToast),
          _createVNode(_unref(IonRouterOutlet), { id: "main-content" }),
          (_unref(controlStore).isAppContentHidden)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createVNode(_unref(IonButton), { onClick: stopScan }, {
                  default: _withCtx(() => [
                    _hoisted_22
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_23, [
                  (_unref(authStore).version === 'pwa')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24))
                    : (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_27))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})